<template>
  <div id="heatingSmart">
    <div v-if="isFullScreen" class="fullScreenWindow">
      <smart-heat
        @closeFullScreenWindow="closeFullScreenAction"
        @changeDateAction="fullScreenChangeDate"
        :chartsData="charts"
        :isNowDate="isNowDate"
        :selectedDay="selectedMonth"
        :maxOutDoorTemp="maxOutDoorTemp"
        :minOutDoorTemp="minOutDoorTemp"
      ></smart-heat>
    </div>
    <div class="selecteMonth">
      <label>选择月份:</label>
      <el-date-picker
        class="selectedDateWidget"
        v-model="selectedMonth"
        type="date"
        placeholder="请选择日期"
        @change="changeDate"
      ></el-date-picker>
      <!-- <el-button class="okBtn" type="primary" @click="changeMonthAction"
        >确认</el-button
      > -->
      <el-button type="primary" class="fullScreenCls" @click="openFullScreen"
        >全屏</el-button
      >
    </div>
    <div class="contentCls" :style="chartsStyle" ref="chartListBox">
      <div
        v-for="(chartItemData, index) in charts"
        :key="'screen' + index"
        class="chartItem"
        @click="previewChart(chartItemData)"
      >
        <el-image
          class="chartBorderImg"
          fit="fill"
          :src="chartItemData.bgImg"
        ></el-image>
        <div
          v-if="chartItemData.type == 'setTempEquipment'"
          class="chartTitleBox"
          :style="chartTitleStyle"
        >
          <div class="titleCls">
            <div :style="roomTextStyle">
              {{ chartItemData.houseStructureDetail }}
            </div>
            <div :style="roomTextStyle">{{ chartItemData.name }}</div>
          </div>
          <div
            class="runStatus"
            :style="runStatusColor(chartItemData.statusCode)"
          >
            <div :style="chartStatusStyle">{{ chartItemData.runStatus }}</div>
          </div>
        </div>
        <div
          class="maxAndMinTemp"
          v-if="chartItemData.type == 'boiler' && !isNowDate"
        >
          <span class="maxTempCls">室外最高温度: {{ maxOutDoorTemp }}℃</span>
          <span>室外最低温度: {{ minOutDoorTemp }}℃</span>
        </div>
        <div class="chart" v-if="chartItemData.type == 'boiler'">
          <smart-gas-temp-chart
            v-if="isNowDate"
            :chartData="chartItemData"
            :chartIndex="index"
            :equipmentData="charts.length > 1 ? charts[1] : null"
          ></smart-gas-temp-chart>
          <gas-temp-bar-chart
            v-if="!isNowDate"
            :chartIndex="index"
            :xData="[chartItemData.date]"
            :gasData="[chartItemData.gasQuantity]"
          ></gas-temp-bar-chart>
        </div>
        <div class="chart" v-if="chartItemData.type == 'setTempEquipment'">
          <smart-equipment-chart
            :equipmentData="chartItemData"
            :chartIndex="index"
          ></smart-equipment-chart>
        </div>
      </div>
    </div>
    <equipment-popup
      class="equipmentPopup"
      v-if="isShowEquipmentPopup"
      :chartData.sync="selectedChartData"
      @closeEquipmentPopup="closeEquipmentPopUpAction"
    ></equipment-popup>
    <gas-temp-popup
      class="gasTempPopup"
      v-if="isShowGasTempPopup"
      :chartData.sync="selectedChartData"
      :equipmentData="charts.length > 1 ? charts[1] : null"
      :isNowDate="isNowDate"
      :selectedDateStr="selectedMonthStr"
      :maxOutDoorTemp="maxOutDoorTemp"
      :minOutDoorTemp="minOutDoorTemp"
      @closeGasTempPopup="closeGasTempPopupAction"
    ></gas-temp-popup>
  </div>
</template>
<script>
import SmartHeat from "./smartHeatFullScreen";
import EquipmentPopup from "./equipmentChartPopup.vue";
import GasTempPopup from "./gasTempPopup.vue";
import SmartEquipmentChart from "@/components/subComponents/smartEquipmentChart.vue";
import SmartGasTempChart from "@/components/subComponents/smartGasTempChart.vue";
import { mapGetters } from "vuex";
import requestObjc from "@/utils/requestObjc";
import mainStore from "@/store/storeMain";
import GasTempBarChart from "@/components/subComponents/smartGasTempBarChart.vue";
export default {
  name: "heatingSmart",
  store: mainStore,
  components: {
    SmartHeat,
    EquipmentPopup,
    GasTempPopup,
    SmartEquipmentChart,
    SmartGasTempChart,
    GasTempBarChart,
  },
  data() {
    return {
      isFullScreen: false,
      refreshDataTimer: null,
      selectedMonth: Date,
      selectedMonthStr: "2021-03-22",
      isShowEquipmentPopup: false,
      isShowGasTempPopup: false,
      selectedChartData: Object,
      chartTitleStyle: {},
      chartStatusStyle: {},
      roomTextStyle: {},
      columnNum: 2,
      isNowDate: true, //标记当前选中的是否为当前日期
      charts: [],
      maxOutDoorTemp: 0, //最高室外温度
      minOutDoorTemp: 0, //最低室外温度
    };
  },
  computed: {
    ...mapGetters({
      curHouseInfo: "getCurHouseInfo",
    }),
    chartsStyle() {
      var styleObj = {
        gridTemplateColumns: `repeat(${this.columnNum}, minmax(100px, 1fr))`,
      };
      if (this.columnNum == 2 && this.charts.length <= 2) {
        styleObj.height = `400px`;
      }
      if (this.columnNum == 3 && this.charts.length == 3) {
        styleObj.gridTemplateRows = `1fr 1fr`;
      }
      return styleObj;
    },
  },
  watch: {
    isFullScreen(value) {
      if (value) {
        this.stopScroll();
      } else {
        this.move();
      }
    },
    isShowEquipmentPopup(value) {
      if (value) {
        this.stopScroll();
      } else {
        this.move();
      }
    },
    isShowGasTempPopup(value) {
      if (value) {
        this.stopScroll();
      } else {
        this.move();
      }
    },
  },
  props: {},
  mounted() {
    //打开定时器
    if (this.isNowDate) {
      this.refreshDataTimer = setInterval(this.requestData, 10 * 60 * 1000);
    }
    var nowDate = new Date();
    var nowYear = nowDate.getFullYear();
    var nowMonth = nowDate.getMonth() + 1 + "";
    var nowDay = nowDate.getDate();
    if (nowMonth.length == 1) {
      nowMonth = "0" + nowMonth;
    }
    if (nowDay.length == 1) {
      nowDay = "0" + nowDay;
    }
    this.$set(this, "selectedMonth", nowDate);
    this.$set(
      this,
      "selectedMonthStr",
      nowYear + "-" + nowMonth + "-" + nowDay
    );
    //获取数据
    this.requestData();
  },
  methods: {
    //全屏状态下改变日期
    fullScreenChangeDate(changedDate) {
      this.selectedMonth = changedDate;
      this.selectedMonthStr = this.getTimeFromDate(changedDate).split(" ")[0];
      var nowDate = new Date();
      var nowTime = this.getTimeFromDate(nowDate).split(" ")[0];
      if (nowTime == this.selectedMonthStr) {
        this.isNowDate = true;
      } else {
        this.isNowDate = false;
      }
      //重新请求数据
      this.requestData();
    },
    //选择了日期
    changeDate() {
      this.selectedMonthStr = this.getTimeFromDate(this.selectedMonth).split(
        " "
      )[0];
      this.changeMonthAction();
    },
    //日期确认
    changeMonthAction() {
      var nowDate = new Date();
      var nowTime = this.getTimeFromDate(nowDate).split(" ")[0];
      if (nowTime == this.selectedMonthStr) {
        this.isNowDate = true;
      } else {
        this.isNowDate = false;
      }
      if (!this.isNowDate) {
        clearInterval(this.refreshDataTimer); //关闭定时器
      } else {
        this.refreshDataTimer = setInterval(this.requestData, 10 * 60 * 1000);
      }
      this.requestData();
    },
    setStyle() {
      if (this.charts.length <= 8 && this.charts.length >= 3) {
        this.columnNum = 3;
      }
      if (this.charts.length > 8 && this.charts.length <= 12) {
        this.columnNum = 4;
      }
      if (this.charts.length > 12) {
        this.columnNum = Math.floor(this.charts.length / 3) + 1;
      }
      this.setChartTitleStyle();
    },
    //请求数据
    requestData() {
      this.$set(this, "charts", []);
      var gateway = this.curHouseInfo.gatewayId;
      var params = {
        date: this.selectedMonthStr,
      };
      requestObjc
        .requestSmartHeatingEnergys(params, gateway)
        .then((res) => {
          this.finishingChartData(res.data);
          this.getMaxAndMinTemp(res.data.setTempEquipment);
        })
        .catch((err) => {
          console.log("获取智能采暖系统数据失败：" + err);
        });
    },
    //获取最高室外温度和最低室外温度
    getMaxAndMinTemp(chartList) {
      if (chartList.length == 0) return;
      var equipmentData = chartList[0];
      var maxTemp = 0;
      var minTemp = 0;
      for (let i = 0; i < equipmentData.temps.length; i++) {
        var outTemp = equipmentData.temps[i].outDoorTemp;
        if (outTemp == null) break;
        if (i == 0) {
          maxTemp = outTemp;
          minTemp = outTemp;
        }
        if (maxTemp < outTemp) {
          maxTemp = outTemp;
        }
        if (minTemp > outTemp) {
          minTemp = outTemp;
        }
      }
      this.maxOutDoorTemp = maxTemp;
      this.minOutDoorTemp = minTemp;
    },
    //数据处理
    finishingChartData(resData) {
      var newResData = resData;
      if (this.isNowDate && resData.boilers.length != 0) {
        newResData.boilers[0].gasQuantity.forEach((boilerItem) => {
          boilerItem.dateTime = this.gasDateFinishing(boilerItem.dateTime);
        });
      }
      newResData.setTempEquipment.forEach((element) => {
        element.temps.forEach((tempItem) => {
          tempItem.dateTime = this.finishingDate(tempItem.dateTime);
        });
      });
      this.setChartData(newResData);
    },
    //气量时间处理
    gasDateFinishing(dateTime) {
      var dateStrList = dateTime.split(" ");
      var dayStr = dateStrList[0];
      var hour = parseInt(dateStrList[1].split(":")[0]);
      var minutes = parseInt(dateStrList[1].split(":")[1]);
      if (minutes > 30) {
        hour += 1;
      }
      return dayStr + " " + hour + ":00:00";
    },
    //时间处理
    finishingDate(dateTime) {
      var tempDate = new Date(Date.parse(dateTime.replace("/-/g", "/")));
      var minutes = tempDate.getMinutes();
      var roundMinutes = Math.round(minutes / 10) * 10;
      var seconds = tempDate.getSeconds();
      var newDate =
        tempDate.getTime() -
        minutes * 60 * 1000 +
        roundMinutes * 60 * 1000 -
        seconds * 1000;
      return this.getTimeFromDate(new Date(newDate));
    },
    //对气量数据做处理
    getGasList(gasQuantityList) {
      var gasList = [];
      for (let i = 0; i < gasQuantityList.length; i++) {
        if (gasList.length == 0) {
          gasList.push(gasQuantityList[i]);
          continue;
        }
        var gasItem;
        gasList.forEach((element) => {
          if (element.dateTime == gasQuantityList[i]) {
            gasItem = element;
            return;
          }
        });
        if (gasItem == null || gasItem == undefined) {
          gasList.push(gasQuantityList[i]);
        } else {
          gasItem.gasQuantity += gasQuantityList[i].gasQuantity;
        }
      }
      return gasList;
    },
    //补全气量温度数据
    finishingGasTempData(data) {
      var boilerGasObjc = {
        id: data.boilers[0].id,
        name: data.boilers[0].name,
        date: this.selectedMonthStr,
        bgImg: require("@/assets/chartBorderBg1.png"),
        noneBgImg: require("@/assets/normal-border.png"),
        type: "boiler",
      };
      if (!this.isNowDate) {
        boilerGasObjc.gasQuantity = Math.floor(
          data.boilers[0].gasQuantity / 100
        );
      } else {
        var nowDateStr1 =
          this.selectedMonthStr.replace("/-/g", "/") + " " + "00:00:00";
        var nowTime1 = Date.parse(nowDateStr1);
        var boilerGas = this.getGasList(data.boilers[0].gasQuantity);
        boilerGasObjc.gasQuantity = [];
        for (let i = 0; i < 24; i++) {
          if (boilerGas.length == 0) {
            boilerGasObjc.gasQuantity.push({
              dateTime: this.getTimeFromDate(new Date(nowTime1)),
              gasQuantity: null,
            });
          } else {
            var flag = true;
            for (let j = 0; j < boilerGas.length; j++) {
              var itemData = boilerGas[j];
              var itemTime = Date.parse(itemData.dateTime.replace("/-/g", "/"));
              var poor = Math.abs(itemTime - nowTime1);
              if (poor < 10000) {
                itemData.gasQuantity = Math.floor(itemData.gasQuantity) / 100;
                flag = false;
                boilerGasObjc.gasQuantity.push(itemData);
                break;
              }
            }
            if (flag) {
              boilerGasObjc.gasQuantity.push({
                dateTime: this.getTimeFromDate(new Date(nowTime1)),
                gasQuantity: null,
              });
            }
          }
          nowTime1 = nowTime1 + 60 * 60 * 1000;
        }
      }
      return boilerGasObjc;
    },
    //数据补全
    setChartData(data) {
      var chartDataList = [];
      if (data.boilers.length != 0) {
        chartDataList.push(this.finishingGasTempData(data));
      }
      ///---------整理设温数据部分
      data.setTempEquipment.forEach((element) => {
        //获取当前日期的时间戳
        var nowDateStr =
          this.selectedMonthStr.replace("/-/g", "/") + " " + "00:00:00";
        var nowTime = Date.parse(nowDateStr);
        var equipmentData = {
          type: "setTempEquipment",
          id: element.id,
          name: element.name,
          houseStructureDetail: element.houseStructureDetail,
          bgImg: require("@/assets/chartBorderBg3.png"),
          noneBgImg: require("@/assets/basic-border.png"),
          statusCode: 0,
          runStatus: "",
          temps: [],
        };
        for (let i = 0; i < 144; i++) {
          if (element.temps.length == 0) {
            equipmentData.temps.push({
              dateTime: this.getTimeFromDate(new Date(nowTime)),
              setTemperature: null,
              inDoorTemp: null,
              outDoorTemp: null,
            });
          } else {
            var flag = true;
            for (let j = 0; j < element.temps.length; j++) {
              var itemData = element.temps[j];
              var itemTime = Date.parse(itemData.dateTime.replace("/-/g", "/"));
              var poor = Math.abs(itemTime - nowTime);
              if (itemData.setTemperature == 0) itemData.setTemperature = null;
              if (itemData.inDoorTemp == 0) itemData.inDoorTemp = null;
              if (poor < 10000) {
                flag = false;
                equipmentData.temps.push(itemData);
                break;
              }
            }
            if (flag) {
              equipmentData.temps.push({
                dateTime: this.getTimeFromDate(new Date(nowTime)),
                setTemperature: null,
                inDoorTemp: null,
                outDoorTemp: null,
              });
            }
          }
          nowTime = nowTime + 60 * 10 * 1000;
        }
        chartDataList.push(equipmentData);
      });
      this.$set(this, "charts", chartDataList);
      this.$nextTick(() => {
        this.setStyle();
      });
    },
    //时间戳转换成日期
    getTimeFromDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1 + "";
      var day = date.getDate();
      var hour = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      month = month.length == 1 ? "0" + month : month;
      day = day.toString().length == 1 ? "0" + day : day;
      minutes = minutes.toString().length == 1 ? "0" + minutes : minutes;
      hour = hour.toString().length == 1 ? "0" + hour : hour;
      seconds = seconds.toString().length == 1 ? "0" + seconds : seconds;
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    setChartTitleStyle() {
      var numFlag1 = this.charts.length / this.columnNum;
      var numFlag2 = Math.floor(this.charts.length / this.columnNum);
      var rowNum = numFlag2 < numFlag1 ? numFlag2 + 1 : numFlag1;
      if (this.$refs.chartListBox == undefined) return;
      var chartsBoxHeight = this.$refs.chartListBox.offsetHeight;
      var chartItemHeight = Math.ceil(chartsBoxHeight / rowNum);
      var titleBoxHeight = (chartItemHeight * 7) / 100;
      if (titleBoxHeight - 4 > 12) return;
      var titleFontSize = titleBoxHeight - 8 < 12 ? 12 : titleBoxHeight - 8;
      var transFrom =
        titleBoxHeight - 8 < 12
          ? "scale(" + 6 / 12 + "," + 6 / 12 + ")"
          : "scale(1,1)";
      var statusTransfrom =
        titleBoxHeight - 8 < 12
          ? "scale(" + 8 / 12 + "," + 8 / 12 + ")"
          : "scale(1,1)";
      this.chartTitleStyle = {
        height: titleBoxHeight + "px",
        fontSize: titleFontSize + "px",
      };
      this.roomTextStyle = {
        fontSize: titleFontSize + "px",
        transform: transFrom,
      };
      this.chartStatusStyle = {
        fontSize: titleFontSize + "px",
        transform: statusTransfrom,
      };
    },
    //关闭机电设备图表预览弹窗
    closeEquipmentPopUpAction() {
      this.isShowEquipmentPopup = false;
    },
    //关闭气量和温度图表预览弹窗
    closeGasTempPopupAction() {
      this.isShowGasTempPopup = false;
    },
    previewChart(chartItem) {
      this.selectedChartData = chartItem;
      if (chartItem.type == "boiler") {
        this.isShowGasTempPopup = true;
        return;
      }
      this.isShowEquipmentPopup = true;
    },
    runStatusColor(statusCode) {
      if (statusCode == 3) {
        return "color: #FF4B82";
      }
      return "color: #4BCEFF";
    },
    //全屏
    launchFullScreen() {
      var element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    //关闭全屏
    closeFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    openFullScreen() {
      this.isFullScreen = true;
      this.launchFullScreen();
    },
    closeFullScreenAction() {
      this.isFullScreen = false;
      this.closeFullScreen(this.$refs.fullScreen);
    },
    stopScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    move() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
  },
};
</script>
<style scoped>
#heatingSmart {
  width: 100%;
  height: 100%;
}
.fullScreenCls {
  width: 80px;
  height: 40px;
  margin-left: 80px;
}
.fullScreenWindow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.selecteMonth {
  width: 100%;
  text-align: left;
  margin-left: 50px;
}
.selectedDateWidget,
.okBtn {
  margin-left: 20px;
}
.contentCls {
  width: 100%;
  height: 600px;
  margin: 0 auto;
  margin-top: 20px;
  display: grid;
}
.chartItem {
  position: relative;
  margin: 20px 10px;
  box-sizing: border-box;
  overflow: hidden;
}
.maxAndMinTemp {
  font-size: 12px;
  position: absolute;
  z-index: 3;
  height: 10%;
  top: 5%;
  width: 100%;
  color: #4bceff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chartTitleBox {
  font-size: 16px;
  position: absolute;
  height: 23px;
  top: 3px;
  right: 14%;
  left: 36%;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: start;
}
.titleCls,
.runStatus {
  display: inline-block;
  height: 100%;
}
.titleCls {
  width: 74%;
  height: 100%;
  color: #4bceff;
  display: flex;
  align-items: center;
  justify-content: left;
}
.titleCls div {
  font-size: 12px;
  height: 100%;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
}
.runStatus {
  font-size: 14px;
  width: 18%;
}
.equipmentPopup,
.gasTempPopup {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.chartBorderImg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.chartBorderImg {
  z-index: 1;
}
.chart {
  height: 80%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 10px;
  z-index: 4;
}
.maxTempCls {
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/smartSystems/heatingSmart.vue